import type { GridApi, ColDef } from 'ag-grid-community';
import type { CsvRow } from '../types';

interface AppState {
  gridApi: GridApi | null;
  originalData: CsvRow[];
  columnDefs: ColDef[];
}

const state: AppState = {
  gridApi: null,
  originalData: [],
  columnDefs: []
};

export function getGridApi(): GridApi | null {
  return state.gridApi;
}

export function setGridApi(api: GridApi | null): void {
  state.gridApi = api;
}

export function getOriginalData(): CsvRow[] {
  return state.originalData;
}

export function setOriginalData(data: CsvRow[]): void {
  state.originalData = data;
}

export function getColumnDefs(): ColDef[] {
  return state.columnDefs;
}

export function setColumnDefs(defs: ColDef[]): void {
  state.columnDefs = defs;
}
